import { HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as moment from 'moment';
import { ApiService } from 'src/app/core/api/api.service';
import { PAYMENT_ENDPOINTS } from 'src/app/core/api/endpoints/payment.endpoints';
import { BUTTON_LOADING_ID } from 'src/app/shared/global/http-context-tokens';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  private api = inject(ApiService);

  getOrderReasons(): Observable<any> {
    return this.api.get<any>(PAYMENT_ENDPOINTS.V1.SUB_ORDER_REASONS).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  getAdditionalInvoiceReasons(): Observable<any> {
    return this.api.get<any>(PAYMENT_ENDPOINTS.V1.FINANCIAL_TRANSACTIONS_TYPES);
  }

  calcSubOrderAmount(data): Observable<any> {
    return this.api
      .post<any>(PAYMENT_ENDPOINTS.V1.CALCULATE_SUB_ORDER_AMOUNT, data)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  addAdditionalInvoice(data): Observable<any> {
    return this.api.post<any>(PAYMENT_ENDPOINTS.V1.CREATE_INSPECTOR_FINANCIAL_TRANSACTION, data);
  }

  getInspectorFinancialTransactions(orderId): Observable<any> {
    return this.api.get<any>(PAYMENT_ENDPOINTS.V1.INSPECTOR_FINANCIAL_TRANSACTIONS(orderId));
  }

  creatAdditionalAmount(data): Observable<any> {
    return this.api.post<any>(PAYMENT_ENDPOINTS.V1.CREATE_SUB_ORDER, data).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  createPurchaseProcess(data, id, buttonId): Observable<any> {
    const payload = {
      amount: data.paymentAmount,
      invoice_id: data.purchaseInvoiceNumber,
      payment_method: data.bankName,
      qoyod_customer_id: data.clientNumInQoud,
      receipt_id: data.bondNumber,
      received_on_date: moment(data.paymentDate).format('YYYY-MM-DD'),
    };
    return this.api
      .post<any>(PAYMENT_ENDPOINTS.V1.ORDER_PURCHASE(id), payload, 
        {context: new HttpContext().set(BUTTON_LOADING_ID, buttonId)}
      );
  }

  getPaymentMethods(): Observable<any> {
    return this.api.get<any>(PAYMENT_ENDPOINTS.V1.PAYMENT_METHODS);
  }

  getBanksNames() {
    return this.api.get<any>(PAYMENT_ENDPOINTS.V1.PAYMENT_METHODS).pipe(
      map((data: any) => {
        return data;
      })
    );
  }
}
